import { FilterActionTypes, All } from './filters.action';

export const initialState: any = {
  loading: false,
  result: null,
  errorState: null
};

export interface State {
  loading: boolean;
  result: any | null;
  errorState: string | null;
}

export function reducer(state = initialState, action: All): State {
  switch (action.type) {
    case FilterActionTypes.Filters_Request: {
      return {
        ...state,
        loading: true,
        result: null,
        errorState: null
      };
    }
    case FilterActionTypes.Filters_Failure: {
      return {
        ...state,
        loading: false,
        result: null,
        errorState: 'Failed to get filters'
      };
    }
    case FilterActionTypes.Filters_Success: {
      return {
        ...state,
        loading: false,
        result: action.payload.filters,
        errorState: null
      };
    }
    default: {
      return state;
    }
  }
}
